import { Component, Input, OnInit } from '@angular/core';
import { CustomerInterface } from '../../../account/models/customer.interface';
import { CustomerService } from '../../../account/services/customer.service';

@Component({
  selector: 'app-vies-status',
  standalone: false,
  templateUrl: './vies-status.component.html',
  styleUrl: './vies-status.component.css',
})
export class ViesStatusComponent implements OnInit{

  @Input()
  customer: CustomerInterface;
  isPro: boolean;
  className: string|null;
  description: string|null;
  tooltipVisible = false;
  tooltipPosition = {
    left: 0,
    top: 0
  };
  constructor(private customerService: CustomerService) {
  }

  ngOnInit() {
    this.className = null;
    this.description = null;
    this.isPro = [null, ''].indexOf(this.customer.siret) === -1;
    if (this.isPro) {
      if (
          ['88888888888888', '77777777777777'].indexOf(this.customer.siret) === -1 &&
          this.customer.vatNumber !== null &&
          this.customer.vatNumber.toLowerCase().startsWith('fr')
      ) {
        this.customerService.getVatNumberStatus().subscribe(
            response => {
              this.className = 'status ';
              if (response.status == 'completed' && response.vatNumberStatus) {
                this.className += 'valid';
                this.description = 'Ce numéro de TVA a été validé sur le portail VIES de la commission européenne.';
              } else if (response.status == 'error' || (response.status == 'completed' && !response.vatNumberStatus)) {
                this.className += 'error';
                this.description = 'Ce numéro de TVA a été invalidé sur le portail VIES de la commission européenne.';
              } else {
                this.className += 'in-progress';
                this.description = 'En cours de vérification.';
              }
            }
        );
      }
    }
  }

  handleTooltip(event: MouseEvent): void {
    const icon = event.currentTarget as HTMLElement;
    const rect = icon.getBoundingClientRect();

    this.tooltipPosition = {
      left: rect.left + 20,
      top: rect.top - 15
    };

    this.tooltipVisible = true;
  }

  /**
   * hide tooltip
   */
  hideTooltip(): void {
    this.tooltipVisible = false;
  }
}
